import { CircularProgress } from '@mui/material';
import React, { lazy, Suspense, useMemo } from 'react';
import { FullWidthCenterBox } from '../../component/layout/BoxLayout';
import { BikeleasingVendorOnline } from './BikeleasingVendorOnline';

const BikeleasingVendorMapWrapper = lazy(() => import('./map/BikeleasingVendorMapWrapper'));

export enum BikeleasingVendorTabs {
  MAP = 'MAP',
  ONLINE = 'ONLINE',
}

interface Props {
  tab?: BikeleasingVendorTabs;
}

export const BikeleasingVendorContent: React.FC<Props> = ({ tab }): React.JSX.Element | null => {
  const component = useMemo(() => {
    switch (tab) {
      case BikeleasingVendorTabs.MAP:
        return (
          <Suspense
            fallback={
              <FullWidthCenterBox sx={{ mt: 10 }}>
                <CircularProgress />
              </FullWidthCenterBox>
            }
          >
            <BikeleasingVendorMapWrapper />
          </Suspense>
        );
      case BikeleasingVendorTabs.ONLINE:
        return <BikeleasingVendorOnline />;

      default:
        return null;
    }
  }, [tab]);

  return <>{component}</>;
};
